<template>
  <div>
    <div
      v-for="(service, key) in servicesWithProgress"
      :key="key"
      class="service-item mt-3 rounded"
    >
      <div
        class="d-flex justify-content-between shadow-sm px-3 py-1 mb-2 "
        data-toggle="collapse"
        role="button"
        aria-expanded="false"
        aria-controls="multiCollapseExample1"
        :href="`#${serviceItemId(key)}`"
        :class="{
          displayed: service.displayed,
          rounded: !service.displayed,
          'has-error': isValidating && service.hasError,
        }"
        @click="display(service)"
      >
        <div class="mt-1">
          <a
            class="service-item-collapse-button text-white rounded-circle mr-2"
            :class="{
              'bg-teal': !isValidating && service.hasError,
              'fas fa-angle-right': service.hasError && !service.displayed,
              'bg-success':
                !service.hasError || (!isValidating && service.displayed),
              'fas fa-check fa-xs': !service.hasError,
              'fas fa-angle-down': service.hasError && service.displayed,
              'bg-red': isValidating && service.hasError,
            }"
          ></a>
          <span class="fs-16 font-weight-bold">{{ service.areaName }}</span>
        </div>
        <div class="d-flex justify-content-end">
          <Error
            v-if="isValidating && service.hasError"
            :message="msg"
            variant="no-border"
            :is-alert-mode="false"
            class="px-3 py-1"
          />
          <div
            class="service-item-progress px-3 py-1"
            :class="{
              'bg-white-success': !service.hasError,
              'bg-white border-teal': !isValidating && service.hasError,
              'has-error': isValidating && service.hasError,
            }"
          >
            <span
              v-if="
                service.objectivesCompleted == 0 && hasNoAvialableWeek(service)
              "
            >
              N/A
            </span>
            <span v-else>
              {{
                `${service.objectivesCompleted} de ${service.objectivesCount}`
              }}
            </span>
          </div>
        </div>
      </div>
      <div :id="serviceItemId(key)" class="collapse multi-collapse">
        <div class="p-4">
          <slot :item="service"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Error from '@/components/common/Error.vue';
export default {
  name: 'EducationalServices',
  components: {
    Error,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isValidating: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    msg: 'Tienes Objetivos sin documentar en este informe de progreso',
  }),
  computed: {
    weekParam() {
      const w = parseInt(this.$route.params.week);
      return isNaN(w) ? 1 : w;
    },
    serviceItemId: () => (key) => `educational-service-collapse-${key}`,
    servicesWithProgress() {
      return this.items.map((service) => {
        const weekly = service.weeklyPeriods?.[this.weekParam - 1] || {
          objectivesCompleted: 0,
          objectivesCount: 0,
        };
        const objectives =
          service.subAreas?.flatMap((a) => a.objectives ?? []) || [];
        const objectivesCount =
          weekly.objectivesCount || objectives.length || 0;
        const objectivesCompleted =
          weekly.objectivesCompleted ||
          objectives.filter(
            (o) => o.completed === true || o.completed === 'true'
          ).length ||
          0;
        const finalCompleted = Math.min(objectivesCompleted, objectivesCount);

        const hasError = finalCompleted !== objectivesCount;

        return {
          ...service,
          objectivesCount,
          objectivesCompleted: finalCompleted,
          hasError,
        };
      });
    },
  },
  methods: {
    display(service) {
      this.$emit('display', service);
    },
    hasNoAvialableWeek(service) {
      const objectives =
        service?.subAreas?.flatMap((subArea) => subArea.objectives) ?? [];
      const weeks =
        objectives.flatMap((objective) => objective.weekDetail) ?? [];

      return (
        weeks.some((weekDetail) => weekDetail.availableForWeek === false) ??
        false
      );
    },
  },
};
</script>
<style scoped lang="scss">
.service-item {
  background-color: #efefef;
}
.service-item > div:first-child {
  border-radius: 0.25rem 0.25rem 0px 0px;
}
.service-item > div:nth-child(2) {
  border-radius: 0px 0px 0.25rem 0.25rem;
}
.bg-teal {
  background-color: #3f5b60;
}
.fs-16 {
  font-size: 16px;
}
.service-item-collapse-button {
  height: 24px;
  width: 24px;
  text-align: center;
  padding-top: 2px;
  border: 2px solid white;
  cursor: pointer;
  text-decoration: none;
}
.service-item-progress {
  border: 1px solid;
  border-radius: 25px;
}
.service-item-progress.bg-white-success {
  background-color: #d7fce9;
  border-color: #9dcbab;
}
.service-item-progress.border-teal {
  border-color: #afbfb9;
}

.service-item-collapse-button.fa-check {
  padding-top: 5px !important;
}
.has-error {
  background: #ffebeb;
  border: solid 1px #ff5b5c;
}
.bg-red {
  background-color: #fc5a5b;
}
</style>
